export default __webpack_public_path__ + "static/media/afyanx_logo.fb18c8b9.png";